module.exports = __webpack_public_path__ + "img/house-for-sale.d901cf9.png";